import React, {useState, useCallback, useEffect} from 'react';
import {Modal} from "../../../utils/modal/Modal";
import {coursePeriods, formatErrors, roleTechnicalSpecialist, userStatusFired} from "../../../constants";
import {useDispatch} from "react-redux";
import {toast} from "react-toastify";
import {SelectModal} from "../../../utils/select/SelectModal";
import {clientsCuratorAction} from "../../../actions/clientAction";
import {getCountClientsByProgramLevelAction} from "../../../actions/usersAction";
import {InputModal} from "../../../utils/input/InputModal";

export function ClientsCuratorModal({users, checked, trigger, onSuccess}) {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({
    curator_from: '',
    curator_to: '',
    client_ids: Object.keys(checked),
    client_count: 0,
    program_level: -1
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [countProgramLevel, setCountProgramLevel] = useState(0);
  const dispatch = useDispatch();

  const handleOpen = (value) => {
    if (loading) {
      return;
    }
    setOpen(value);
  };

  const handleChangeForm = useCallback((e) => {
    const name = e.target.name;
    const value = e.target.value;
    setForm((form) => {
      return {...form, [name]: value}
    });
    setErrors((errors) => {
      return {...errors, [name]: value.trim() === ''}
    });

    if(name === 'program_level' && form.curator_from && value > -1){
      // запросить сколько пользователей у куратора
      dispatch(getCountClientsByProgramLevelAction({curator_from: form.curator_from, program_level: Number(value)})).then((data) => {
        setLoading(false);
        setCountProgramLevel(data.count)
      }).catch((e) => {
        setLoading(false);
        toast.error(formatErrors([e.message]), {position: toast.POSITION.BOTTOM_RIGHT});
      });
    }

    if(name === 'curator_from'){
      setCountProgramLevel(0)
    }

  }, [form]);

  const handleChangeNumber = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setForm((form) => {
      return {...form, [name]: value === '' ? '' : value * 1}
    });
  };

  const handleSubmit = () => {
    if (loading) {
      return false;
    }
    let errs = {};
    if (!form.curator_to) {
      errs.curator_to = true;
    }
    if (form.client_ids.length === 0 && !form.curator_from) {
      errs.curator_from = true;
    }
    if (form.client_ids.length === 0 && form.curator_from === form.curator_to) {
      errs.curator_from = true;
      errs.curator_to = true;
    }
    setErrors(errs);
    if (Object.keys(errs).length > 0) {
      return;
    }
    setLoading(true);

    form.program_level = Number(form.program_level);

    dispatch(clientsCuratorAction(form)).then(() => {
      setLoading(false);
      onSuccess();
      setOpen(false);
    }).catch((e) => {
      setLoading(false);
      toast.error(formatErrors([e.message]), {position: toast.POSITION.BOTTOM_RIGHT});
    });
  };

  useEffect(() => {
    if (open) {
      setForm({
        curator_from: '',
        curator_to: '',
        client_ids: Object.keys(checked),
        client_count: 0,
        program_level: -1
      });
      setErrors({});
      setCountProgramLevel(0)
    }
  }, [open, checked]);

  return <Modal isStatic={true} open={open} handleOpen={handleOpen} trigger={trigger} triggerWrap={false}>
    <React.Fragment>
      <div className="modal__title">Сменить куратора</div>
      <p className="modal__subtitle">Выбрано пользователей: <span>{form.client_ids.length}</span></p>
      <div className="modal__inner">
        {form.client_ids.length === 0 && <SelectModal title="Всех пользователй куратора"
                                                    name="curator_from"
                                                    value={form.curator_from}
                                                    error={errors.curator_from}
                                                    disabled={loading}
                                                    onChange={handleChangeForm}>
          <option value="">Выберите</option>
          {
            users.map(i => i.value && (i.role_id !== roleTechnicalSpecialist) && (i.status !== userStatusFired) && <option key={i.value} value={i.value}>{i.text}</option>)
          }
        </SelectModal>}
        {form.client_ids.length === 0 && 
        <InputModal type="number"
                 title="Количество клиентов (0=all)"
                 name="client_count"
                 value={form.client_count}
                 error={errors.client_count}
                 disabled={loading}
                 onChange={handleChangeNumber}/>}

        <div className={"modal__group pr-stage"}>
          {form.client_ids.length === 0 &&
          <SelectModal title="Ступень программы"
                       name="program_level"
                       value={form.program_level}
                       error={errors.program_level}
                       disabled={loading}
                       onChange={handleChangeForm}>
            <option value={-1}>Выберите</option>
            {coursePeriods.map((i, k) => <option key={k} value={k}>{i.title}</option>)}
          </SelectModal>}

          <div >Клиентов на программе: {countProgramLevel}</div>
        </div>

        <SelectModal title="Передать куратору"
                     name="curator_to"
                     value={form.curator_to}
                     error={errors.curator_to}
                     disabled={loading}
                     onChange={handleChangeForm}>
          <option value="">Выберите</option>
          <option value="distribute_to_all">Распределить по всем</option>
          {
            users.map(i => i.value && (i.role_id !== roleTechnicalSpecialist) && (i.status !== userStatusFired) && <option key={i.value} value={i.value}>{i.text}</option>)
          }
        </SelectModal>
      </div>
      <div className="modal__btns">
        <button type="button" className="modal__btn btn" onClick={handleSubmit} disabled={loading}>Передать</button>
      </div>
    </React.Fragment>
  </Modal>
};
